import { useCallback } from "react";
import { dispatcher } from "../store";
import { useStoreSelector } from "./redux/useStoreSelector";
import { useFetching } from "./system/useFetching";
import { useNotify } from "./system/useNotify";
import { useApi } from "./useApi";

export function useBalances() {
  const balances = useStoreSelector( s => s.balances),
    profile = useStoreSelector( s => s.user.profile),
    {withFetching} = useFetching(),
    {addNotify, handleApiError} = useNotify()

  const {api, isAuth} = useApi()

  const loadBalances = useCallback(async (id: number) => {
    if (profile && isAuth) {
      try {
        const res = await withFetching(api.getPortfoliosByIdBalances({id}))
        const body = handleApiError(res)
        if (body) {
          if (body["client_portfolio"]) {
            dispatcher.balances.setClientPortfolio(body["client_portfolio"]);
          } else {
            dispatcher.balances.unsetClientPortfolio();
          }
          if (body["client_cash_portfolio"]) {
            dispatcher.balances.setClientCashPortfolio(body["client_cash_portfolio"]);
          } else {
            dispatcher.balances.unsetClientCashPortfolio();
          }
          if (body["client_margin_portfolio"]) {
            dispatcher.balances.setClientMarginPortfolio(body["client_margin_portfolio"]);
          } else {
            dispatcher.balances.unsetClientMarginPortfolio();
          }
        }
      } catch (e) {
        addNotify('error', 'Error', e.message)
      }
    }
  }, [addNotify, api, handleApiError, isAuth, profile, withFetching])

  return {balances, loadBalances}
}
